import React, { Component } from 'react'
import { connect } from 'react-redux'
import Dialog, {
  DialogContent,
  DialogTitle,
  DialogActions,
} from 'material-ui/Dialog'
import Button from 'material-ui/Button'
import { HIDE_CAR_MAKE_MODAL } from '../../../actionTypes/make'
import Loading from '../../../components/Loading'
import MakesModelSelectsForms from './makesModelSelectsForms'
import { submit } from 'redux-form'
import { fetchMakes } from './actions'
import { configuration } from '../../../configuration'

class CarMakeModelDialog extends Component {

  componentWillMount() {
    this.props.dispatch(fetchMakes());
  }

  handleOnClose = () => {
    // TODO: Save data to query params before closing
    this.props.dispatch({
      type: HIDE_CAR_MAKE_MODAL,
    })
  }

  submit = () => {
    const makesModelSelectsForms = this.props.makesModelSelectsForms
    this.props.dispatch(submit('makesModelSelectsForms'))
    if (!makesModelSelectsForms.syncErrors) {
      this.handleOnClose()
    }
  }

  render() {
    const { showCarMakeDialog, makes } = this.props;
    return (
      <Dialog
        open={!!showCarMakeDialog}
        onClose={this.handleOnClose}
        disableEscapeKeyDown
        disableBackdropClick
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>
          {configuration().brandName == 'Mazda' ? 'Cuéntanos un poco más acerca de tu Mazda' : 'Cuéntanos un poco más acerca de tu coche'}
        </DialogTitle>
        <DialogContent>
          {
            Array.isArray(makes)
              ? <MakesModelSelectsForms />
              : <Loading />
          }
        </DialogContent>
        <DialogActions>
          <Button onClick={this.submit} color="primary">Confirmar datos</Button>
        </DialogActions>
      </Dialog>
    )
  }
}

const mapStateToProps = state => ({
  showCarMakeDialog: state.make.showCarMakeModal,
  currentMake: state.make.currentMake,
  makes: state.make.makes,
  makesModelSelectsForms: state.form.makesModelSelectsForms,
})

export default connect(mapStateToProps)(CarMakeModelDialog);



// WEBPACK FOOTER //
// ./src/workflow/checkout/checkoutContent/carMakeModelDialog.js